import * as colors from './colors';
import { font } from './font';

export enum BreakpointNames {
  /** @description < 1550px  */
  xxl = 'xxl',

  /** @description < 1250px  */
  xl = 'xl',

  /** @description < 992px  */
  lg = 'lg',

  /** @description < 768px  */
  md = 'md',

  /** @description < 480px  */
  sm = 'sm',
}

export type Breakpoints = { [key in BreakpointNames]: string };

export type ThemeColors = keyof typeof colors['colors'];

export type FontFamilies = keyof typeof font['fonts'];

export type FontWeights = keyof typeof font['fontWeights'];
